import _bundle from '../core--bundles';

export default function() {
    _bundle.add({
        name: 'Module: Test Page Update',
        event: ['on:PageUpdate'],
        weight: 550,
        fn() {
            $('#event-test-jquery').prepend($(`<li>Bundle Done!</li>`));
        }
    });
}
